/* Moon Kiln announcement lightbox (sections/mk-lightbox.liquid).
   Opens once per visitor per campaign key, a few seconds after load.
   Desktop: hovering or tabbing to a name zooms the photo to that piece.
   Mobile: bottom sheet that follows the finger and closes past 120px. */
(function () {
  var MOBILE = '(max-width: 749px)';
  var DRAG_CLOSE = 120;

  function init(root) {
    if (!root || root.mkLightbox) return;
    root.mkLightbox = true;

    var card = root.querySelector('[data-mk-lb-card]');
    var zoom = root.querySelector('[data-mk-lb-zoom]');
    var ring = root.querySelector('[data-mk-lb-ring]');
    var img = root.querySelector('img.mk-lb__img');
    var traitEl = root.querySelector('[data-mk-lb-trait]');
    var pals = Array.prototype.slice.call(root.querySelectorAll('.mk-lb__pal'));
    var design = !!(window.Shopify && window.Shopify.designMode);
    var key = 'mk-lb:' + (root.getAttribute('data-key') || 'default');
    var delay = (parseFloat(root.getAttribute('data-delay')) || 3) * 1000;
    var state = 'wait';
    var lastFocus = null;
    var leaveTimer, closeTimer;

    function seen() {
      try { return !!localStorage.getItem(key); } catch (e) { return false; }
    }
    function markSeen() {
      try { localStorage.setItem(key, String(Date.now())); } catch (e) { /* noop */ }
    }
    function isMobile() { return window.matchMedia(MOBILE).matches; }
    function track(event, props) {
      if (design || !window.posthog || !window.posthog.capture) return;
      props = props || {};
      props.campaign = root.getAttribute('data-key');
      props.layout = isMobile() ? 'sheet' : 'modal';
      window.posthog.capture(event, props);
    }
    // Stay out of the way of the cart drawer, menu drawer and other modals.
    function busy() {
      return document.body.classList.contains('overflow-hidden') ||
        !!document.querySelector('cart-drawer.active, .mk-hdr__drawer-root:not([hidden])');
    }

    function open() {
      if (state !== 'wait') return;
      // Kill switch: the PostHog flag mk-lightbox evaluated to false
      // (snippets/mk-posthog.liquid sets the class). Fails open.
      if (!design && document.documentElement.classList.contains('mk-off-mk-lightbox')) return;
      if (!design && busy()) { setTimeout(open, 2000); return; }
      state = 'open';
      clearTimeout(closeTimer);
      root.classList.remove('is-closing', 'is-dragging');
      root.style.removeProperty('--mk-lb-drag');
      root.style.removeProperty('--mk-lb-dim');
      root.hidden = false;
      lastFocus = document.activeElement;
      if (isMobile()) document.body.classList.add('overflow-hidden');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('is-in');
          if (!design) card.focus({ preventScroll: true });
        });
      });
      if (!design) { markSeen(); track('lightbox_shown'); }
    }

    function close(how) {
      if (state !== 'open') return;
      state = 'closing';
      root.classList.remove('is-dragging');
      root.classList.add('is-closing');
      document.body.classList.remove('overflow-hidden');
      if (how) track('lightbox_dismissed', { method: how });
      closeTimer = setTimeout(function () {
        root.hidden = true;
        root.classList.remove('is-in', 'is-closing');
        resetPal();
        state = design ? 'wait' : 'closed';
        if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
      }, isMobile() ? 450 : 260);
    }

    // The photo is lazy so it costs nothing for returning visitors; pull it in
    // just before the lightbox opens so it never pops in mid-animation.
    function whenImageReady(cb) {
      if (!img) return cb();
      img.loading = 'eager';
      if (img.complete) return cb();
      var done = false;
      function go() { if (!done) { done = true; cb(); } }
      img.addEventListener('load', go, { once: true });
      img.addEventListener('error', go, { once: true });
      setTimeout(go, 4000);
    }
    function whenVisible(cb) {
      if (!document.hidden) return cb();
      document.addEventListener('visibilitychange', function onVis() {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVis);
        setTimeout(cb, 1000);
      });
    }

    /* ---- Desktop: find the pal ---- */
    function setPal(i) {
      clearTimeout(leaveTimer);
      if (isMobile()) return;
      var btn = pals[i];
      var x = parseFloat(btn.getAttribute('data-x'));
      var y = parseFloat(btn.getAttribute('data-y'));
      pals.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
      zoom.style.transform = 'scale(1.3) translate(' + (50 - x) * 0.75 + '%, ' + (55 - y) * 0.75 + '%)';
      ring.style.left = x + '%';
      ring.style.top = y + '%';
      ring.style.opacity = 1;
      if (traitEl) traitEl.textContent = btn.getAttribute('data-trait') || traitEl.getAttribute('data-default');
    }
    function resetPal() {
      pals.forEach(function (p) { p.classList.remove('is-active'); });
      if (zoom) zoom.style.transform = '';
      if (ring) ring.style.opacity = '';
      if (traitEl) traitEl.textContent = traitEl.getAttribute('data-default');
    }
    function leavePals() {
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(resetPal, 160);
    }
    pals.forEach(function (btn, i) {
      btn.addEventListener('mouseenter', function () { setPal(i); });
      btn.addEventListener('focus', function () { setPal(i); });
      btn.addEventListener('click', function () { setPal(i); });
      btn.addEventListener('blur', leavePals);
    });
    var row = root.querySelector('[data-mk-lb-pals]');
    if (row) row.addEventListener('mouseleave', leavePals);

    /* ---- Mobile: drag the sheet down to dismiss ---- */
    var dragging = false, y0 = 0, dy = 0;
    card.addEventListener('pointerdown', function (e) {
      if (state !== 'open' || !isMobile() || e.target.closest('a,button')) return;
      dragging = true;
      y0 = e.clientY;
      dy = 0;
      try { card.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      root.classList.add('is-dragging');
    });
    card.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dy = Math.max(0, e.clientY - y0);
      root.style.setProperty('--mk-lb-drag', dy + 'px');
      root.style.setProperty('--mk-lb-dim', Math.max(0, 1 - dy / 400));
    });
    function release() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      if (dy > DRAG_CLOSE) {
        close('drag');
      } else {
        root.style.removeProperty('--mk-lb-drag');
        root.style.removeProperty('--mk-lb-dim');
      }
    }
    card.addEventListener('pointerup', release);
    card.addEventListener('pointercancel', release);

    /* ---- Close, keyboard ---- */
    root.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-mk-lb-close]');
      if (closer) { close(closer.getAttribute('data-mk-lb-close')); return; }
      if (e.target.closest('[data-mk-lb-cta]')) track('lightbox_clicked');
    });
    document.addEventListener('keydown', function (e) {
      if (state !== 'open') return;
      if (e.key === 'Escape') { close('esc'); return; }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(card.querySelectorAll('a[href], button'), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || active === card)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
      else if (!card.contains(active)) { e.preventDefault(); first.focus(); }
    });

    if (design) {
      // In the theme editor: show while the section or one of its pals is selected.
      var section = root.closest('.shopify-section') || root;
      section.addEventListener('shopify:section:select', function () { state = 'wait'; open(); });
      section.addEventListener('shopify:section:deselect', function () { close(); });
      section.addEventListener('shopify:block:select', function (e) {
        state = state === 'open' ? 'open' : 'wait';
        open();
        var i = pals.indexOf(e.target);
        if (i >= 0) setTimeout(function () { setPal(i); }, 50);
      });
      return;
    }

    if (seen()) { state = 'closed'; return; }
    setTimeout(function () {
      whenVisible(function () { whenImageReady(open); });
    }, delay);
  }

  function boot() {
    document.querySelectorAll('[data-mk-lightbox]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
